import { render } from "./B2CHeaderChart.vue?vue&type=template&id=352bb093&scoped=true&lang=pug"
const script = {}

import "./B2CHeaderChart.vue?vue&type=style&index=0&id=352bb093&lang=sass&scoped=true"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-352bb093"]])

export default __exports__